import { defineMiniApp } from '../../registry';

import { FindingsReviewPanel } from './FindingsReviewPanel';
import { CLINICAL_FINDINGS_AGENT_ID } from './constants';
import { useFindingsActionState } from './useFindingsActionState';

export { FindingsReviewGate } from './review';

export const clinicalFindingsApp = defineMiniApp({
  id: CLINICAL_FINDINGS_AGENT_ID,
  identity: {
    displayName: 'Clinical Findings',
    publisher: 'Eluve',
    trustLevel: 'first-party',
  },
  slots: ['appointment-session'],
  review: {
    label: 'Review findings',
    visible: (context) => Boolean(context.appointmentId),
    surface: 'sidepanel',
    component: FindingsReviewPanel,
  },
  useActionState: useFindingsActionState,
});
